import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <SEO title="Page Not Found" noIndex />
      <div className="text-center">
        <h1 className="text-6xl font-bold text-wl-navy mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-wl-gray mb-4">Page Not Found</h2>
        <p className="text-wl-gray mb-8">
          The page you're looking for doesn't exist.
        </p>
        <Button variant="wl" asChild>
          <a href="/">Go Home</a>
        </Button>
      </div>
    </div>
  );
} 